import React, { useState, useEffect } from 'react';
// import Exp from "express";
import {
  BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import moment from 'moment';
import axios from 'axios';

const MyChart = (props) =>{
  const chart = props.chart;
  const [charts, setCharts] = useState([]);
  useEffect(() => {
    fetchCharts();
  }, []);

  const fetchCharts = async () => {
    try{
      const url = `${process.env.ROOT_DIR}charts/${chart.public_uid}/get_chart`
      axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
      
      const response = await axios.get(url);
      // const sorted = [].concat(response.data.data).sort(function(a,b){
      //   if( a.value > b.value ) return -1;
      //   if( a.value < b.value ) return 1;
      //   return 0;
      // })
      console.log(response.data.data)
      setCharts(response.data.data)
    }catch (error) {
    }
    // console.log(charts)
  }

  function make_array(number){
    var arr = [];
    for(var i = 0 ; i < number ; i++ ){
      arr.push(i)
    }
    return arr
  }

  function set_offset(str){
    if(str === "1M"){
      var time_unix = 1 * 3600 * 24 * 31
    }else if(str === "1W"){
      var time_unix = 1 * 3600 * 24 * 7
    }else if(str === "1D"){
      var time_unix = 1 * 3600 * 24
    }else if(str === "1Y"){
      var time_unix = 1 * 3600 * 24 * 7
    }
    return time_unix
  }
  
  const CustomTooltip = ({ active, payload, label }) => {
    if(payload === null){
      return null;
    }else{

      var sorted = payload;
      sorted.sort(function(a,b){
          if( a.value > b.value ) return -1;
          if( a.value < b.value ) return 1;
          return 0;
      })
      if (active) {
        return (
          <div className="custom-tooltip">
            <div className="label">{
              `${moment.unix(label).utc().format("YYYY-MM-DD")}`
            }</div>
            <div>{sorted
              .map((p, i) => {
                return (
                  p.value !== 0 ? (
                    <div key={i}>{
                      `${p.name}: ${p.value}`  
                    }</div>
                  ) : (<div key={i}></div>)
                )
              })
            }</div>
          </div>
        );
      }
      return null;
    }
  };

  const CustomizedLabel = ({ x, y, fill, value }) => {
    console.log(props)
    return (
      <text
        x={x} 
        y={y} 
        dx={20}
        dy={-4}
        fontSize='16' 
        fontFamily='sans-serif'
        fill={fill}
        textAnchor="middle">
          {value}
      </text>
    )
  }

  const CustomizedAxisTick = ({x, y, stroke, payload}) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} fontSize="12" textAnchor="middle" fill="#666" transform="rotate(0)">{
          moment.unix(payload.value).utc().format("YYYY-MM-DD")
          // payload.value
        }</text>
      </g>
    );
  }

  return(
    <div>
      {chart.title}
      {charts.legends === void 0 ? (
        <div></div>
      ) : (
        <ResponsiveContainer width="95%" height={500}>
          <BarChart
            data={charts.data}
            margin={{top: 5, right: 10, left: 10, bottom: 5}}
            // maxBarSize={10}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name"
                  padding={{left: 40, right: 30 }}
                  domain={[
                    charts.keys[0], charts.keys[1]
                  ]}
                  // domain={[
                  //   Math.floor(new Date(charts.keys[0]).getTime()/1000),
                  //   Math.floor(new Date(charts.keys[1]).getTime()/1000 )
                  // ]}
                  tickFormatter={(d) => 
                    moment.unix(d).utc().format("YYYY-MM-DD")
                  }
                  interval={0}
                  // ticks={[
                  //   Math.floor(new Date(chart.start).getTime() / 1000),
                  //   Math.floor(new Date(chart.end).getTime() / 1000)
                  // ]}
                  ticks={charts.keys}
                  tick={<CustomizedAxisTick />}
                  type='number'
              />
            <YAxis />
            {charts.data.length !== 0 ? (
              <Tooltip
                isAnimationActive={false}
                wrapperStyle={styles.wrapper}
                content={<CustomTooltip />}
              />
            ) : (
              <Tooltip 
                isAnimationActive={false}
                wrapperStyle={styles.wrapper}
              />
              )
            }
            <Legend />
              {/* width={100} wrapperStyle={{ top: 40, right: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '40px' }} 
              /> */}
            {make_array(charts.legends.length).map((val, i) => {
              return charts.legends.length - 1 === i ? (
              //   // return(
              //     <Bar dataKey={charts.legends[val]} fill={charts.color[val]} stackId="" label={<CustomizedLabel />} key={i} />
              //       // ) : (
                <Bar dataKey={charts.legends[val]} fill={charts.color[val]} stackId="" label={{ position: 'top' }} key={i} />
              
              ):(
                <Bar dataKey={charts.legends[val]} fill={charts.color[val]} stackId=""  key={i} />
              )
            })}
          </BarChart>
        </ResponsiveContainer>
      )}
      
    </div>
  )
}

export default MyChart;

const styles = {
  wrapper: {
    minWidth: 64,
    lineHeight: "32px",
    border: '1px solid #333',
    borderRadius: 4,
    padding: "0 16px",
    // color: "#333",
    background: "#fff"
  },
  content: {

  }
};